import {
	AmericanFootballIcon,
	EsportIcon,
	FootballIcon,
	MmaIcon,
	MotorsportIcon,
	RugbyIcon,
	TennisIcon
} from '@capsicum/common-web/icons';
import { useCallback } from 'react';

export const useSportsIcon = () => {
	return useCallback((code?: string) => {
		switch (code) {
			case 'gaming':
				return EsportIcon;
			case 'motor_sports':
				return MotorsportIcon;
			case 'rugby':
				return RugbyIcon;
			case 'tennis':
				return TennisIcon;
			case 'american_football':
				return AmericanFootballIcon;
			case 'football':
				return FootballIcon;
			case 'mma':
				return MmaIcon;
			default:
				return undefined;
		}
	}, []);
};
